<template>
  <div class="block">
    <div class="line">
      <div class="line-name">
        公司名称
      </div>
      <div class="line-value"
      >
        {{accountDetail.name}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        渠道经理
      </div>
      <div class="line-value">
        {{accountDetail.channel_manager_name}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        开户行
      </div>
      <div class="line-value">
        {{accountDetail.bank_name}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        银行卡号
      </div>
       <div class="line-value"
       >
       {{accountDetail.bank_account}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        代理等级
      </div>
      <div class="line-value"
        v-if="accountDetail.level === 0"
      >
      无
      </div>
      <div class="line-value"
        v-if="accountDetail.level === 1"
      >
      铜牌
      </div>
      <div class="line-value"
        v-if="accountDetail.level === 2"
      >
      银牌
      </div>
      <div class="line-value"
        v-if="accountDetail.level === 3"
      >
      金牌
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        代理折扣
      </div>
      <div class="line-value">
        {{accountDetail.discount/10 + '折'}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        是否提交保证金
      </div>
      <div class="line-value"
        v-if="accountDetail.is_pay_deposit === 0"
      >
        否
      </div>
      <div class="line-value"
        v-if="accountDetail.is_pay_deposit === 1"
      >
        是
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        保证金
      </div>
      <div class="line-value">
        {{accountDetail.deposit_price}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accountDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      grade: ''
    }
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.block {
  border-top: 1px #DDDEE1 dashed;
  padding-bottom: 11px;

  .line {
    display: flex;
    padding-top: 10px;
    line-height: 20px;

    .line-name {
      width: 100px;
      font-size: 12px;
      color: #405060;
    }

    .line-value {
      width: 168px;
      margin-left: 10px;
      font-size: 12px;
      color: #80848F;
      overflow: hidden;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agAgentManage/AgentManageLeft.vue